import * as React from 'react';

import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import DateRangeIcon from '@material-ui/icons/DateRange';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { LocalizationProvider, MobileDateRangePicker } from '@material-ui/pickers';
import DateFnsUtils from '@material-ui/pickers/adapter/date-fns';
import deLocale from 'date-fns/locale/de';
import PropTypes from 'prop-types';

import './DatePicker.scss';

const CustomInput = ({ formatedDate, handleDelete, ...rest }) => (
  <TextField
    {...rest}
    className="search-field"
    id="standard-start-adornment"
    variant="standard"
    helperText=""
    label=""
    placeholder=""
    name="datepicker-input"
    disabled
    InputProps={{
      className: 'datepicker-input-field',
      value: formatedDate || '',
      name: 'datepicker-input-field',
      endAdornment: (
        <>
          {formatedDate && <HighlightOffIcon size="small" onClick={handleDelete} />}
          <InputAdornment position="end">
            <DateRangeIcon />
          </InputAdornment>
        </>
      ),
    }}
  />
);
CustomInput.propTypes = {
  formatedDate: PropTypes.string,
  handleDelete: PropTypes.func,
};
CustomInput.defaultProps = {
  formatedDate: '',
  handleDelete: () => {},
};

export const DatePicker = (props) => {
  const { value, setValue, onSubmit } = props;

  const deleteDate = (e) => {
    e.stopPropagation();
    setValue([null, null]);
    onSubmit([null, null]);
  };

  const formatDateRange = (startValue, endValue) => {
    if (startValue && endValue) {
      return `${startValue} - ${endValue}`;
    }
    if (endValue) {
      return `bis ${endValue}`;
    }
    if (startValue) {
      return `ab ${startValue}`;
    }
    return null;
  };

  return (
    <LocalizationProvider dateAdapter={DateFnsUtils}>
      <MobileDateRangePicker
        cancelText=""
        endText="Enddatum"
        startText="Startdatum"
        toolbarTitle="Zeitraum auswählen"
        dateAdapter={new DateFnsUtils({ locale: deLocale })}
        calendars={1}
        mask="__.__.____"
        value={value}
        inputFormat="dd.MM.yyyy"
        onChange={(newValue) => setValue(newValue)}
        onClose={() => {
          onSubmit(value);
        }}
        renderInput={(startProps, endProps) => {
          const formatedDate = formatDateRange(
            startProps.inputProps.value,
            endProps.inputProps.value
          );
          return (
            <CustomInput
              formatedDate={formatedDate}
              handleDelete={deleteDate}
              {...startProps.inputProps}
            />
          );
        }}
      />
    </LocalizationProvider>
  );
};
DatePicker.propTypes = {
  value: PropTypes.array.isRequired,
  setValue: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
